"use strict";

/* import/no-unresolved, import/extensions */
/**
 * Expose I18n, i18nProvider, injectI18n
 */

var I18n = require('./I18n');
var I18nProvider = require('./I18nProvider');
var injectI18n = require('./injectI18n');
module.exports = I18n;
exports = module.exports;
exports.I18n = I18n;
exports.I18nProvider = I18nProvider;
exports.injectI18n = injectI18n;
exports.useI18n = I18nProvider.useI18n;
